import React from 'react';

import { Icon } from '../icons';

export const CheckSaveIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 28 28" fill={color} style={style}>
      <path d="M11.755 19.275L7.20502 14.6989C6.93166 14.4239 6.93166 13.9782 7.20502 13.7032L8.63505 12.25C8.9084 11.975 9.35164 11.975 9.625 12.25L12.25 14.875L18.375 8.7298C18.6484 8.45488 19.0916 8.45488 19.365 8.7298L20.795 10.1831C21.0683 10.458 21.0683 10.9038 20.795 11.1787L12.745 19.2751C12.4716 19.55 12.0284 19.55 11.755 19.275Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5ZM0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
      />
    </svg>
  );
};
